export default __webpack_public_path__ + "static/media/S22_36MK2E5A.2ac9d2f7.jpg";